!function($) {

  // Add custom JavasScript here
  // --------------------------



  // Document ready
  $(function() {

    //UPDATE VARIANT ON THE CART
    $('.item-variants-select').on('change', function (e) {
      const select = e.target,
        newValue = select.value,
        initialValue = select.dataset.initialValue,
        itemKey = select.dataset.itemKey,
        itemProperties = JSON.parse(select.dataset.itemProperties);

      if (select.value === initialValue) return;

      qty = document.getElementById('updates_' + itemKey).value;

      var data = {
        quantity: qty,
        id: newValue,
        properties: itemProperties
      };

      $.ajax({
        type: 'post',
        url: '/cart/add.js',
        data: data,
        success: function (response) {
          let data = {
            quantity: 0,
            id: itemKey
          }
          $.ajax({
            type: 'post',
            url: '/cart/change.js',
            data: data,
            success: function (response) {
              window.location.reload();
            },
            error: function (data) {
              console.debug(data);
            }
          });
        },
        error: function (data) {
          console.debug(data);
          select.value = initialValue;
          if (data.responseText) {
            let response = JSON.parse(data.responseText);
            if (response.description) {
              alert(response.description);
            }
          }
        }
      });
    });
  });

}(jQuery);
